module.exports = __webpack_public_path__ + "img/Corey_Rockafeler.0dde04a.png";